// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__lgtVa","title":"Info_title__2jlSR","selects":"Info_selects__uOOk1","requiredAsterisk":"Info_requiredAsterisk__nmATW"};